export const LOGIN_TYPE_FACEBOOK = 'facebook';
export const LOGIN_TYPE_SMS = 'sms';
export const LOGIN_TYPE_EMAIL = 'email';
export const LOGIN_TYPE_GOOGLE = 'google';
export const LOGIN_TYPE_LINE = 'line';
